import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../../core/actions/expertise.actions';
import * as fromExpertise from '../../core/reducers/expertise.reducer';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { map, startWith, delay, filter } from 'rxjs/operators';
import { Expertise } from '../../shared/models/expertise';
import { ExpertisePanelComponent } from '../expertise-panel/expertise-panel.component';
import { InvoiceService } from '../../shared/services/invoice.service';
import { saveAs } from 'file-saver';
import { FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'app-expertise-tab',
  templateUrl: './expertise-tab.component.html',
  styleUrls: ['./expertise-tab.component.scss']
})
export class ExpertiseTabComponent implements OnInit {

	public expertise: Expertise = new Expertise;

	@Output() expertiseLoaded: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild(ExpertisePanelComponent, {static: false}) expertisePanel: ExpertisePanelComponent;
	displayAcompte: boolean = false;
	displayProvision: boolean = false;
	acompteAmount:FormControl = new FormControl();
  acompteAmountTvac: FormControl =new FormControl();
	edit: boolean = false;
	constructor(private store: Store<any>, private activatedRoute: ActivatedRoute, private invoiceService: InvoiceService) { }


  	ngOnInit() {

      this.acompteAmount.valueChanges.subscribe(v => {
        this.acompteAmountTvac.setValue(v * 1.21, {emitEvent: false});
      });

      this.acompteAmountTvac.valueChanges.subscribe(v => {
        this.acompteAmount.setValue(v / 1.21, {emitEvent: false});
      });

	 	this.activatedRoute.params.subscribe(params => {
		  	if (params && params.id) {
		  		if (params.id > 0) {
		  			this.store.dispatch(new actions.OpenTabAction(params.id));
		  		}

		  		this.store.select(fromExpertise.selectOpenExpertises).pipe(
		  			map((expertises: any[]) => {
	          			return expertises.find(expertise => {
			 				if (expertise.oldId && expertise.oldId.toString() === params.id.toString()) {
	          					return true;
	          				}
		            		return expertise.id.toString() === params.id.toString();
	          			})
		  			}),
		  			filter(c => c && !c.loading)
		  		).subscribe(c => {
		  			this.expertise = c;
		  		});
		    }
		});
	}
	editExpertise() {
		this.expertisePanel.editExpertise();
	}
	doWorkflow(w: any) {
		this.store.dispatch(new actions.ExpertiseWorkflowAction(this.expertise.id, w.action));
	}
	addProvision() {
		//this.acompteAmount = 500;
    this.acompteAmount.patchValue(500);
		this.displayProvision = true;
	}
  printInvoice2() {

		this.invoiceService.getFile2(this.expertise.id).subscribe(b => {

        	const byteCharacters = atob(b.data);
        	const byteArrays = [];

        	for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            	const slice = byteCharacters.slice(offset, offset + 512);

            	const byteNumbers = new Array(slice.length);
            	for (let i = 0; i < slice.length; i++) {
	                byteNumbers[i] = slice.charCodeAt(i);
            	}

	            const byteArray = new Uint8Array(byteNumbers);
            	byteArrays.push(byteArray);
        	}

        	const newBlob = new Blob(byteArrays, { type:"application/pdf" });
        	saveAs(newBlob,"Memoire des frais.pdf");
/*
            const data = window.URL.createObjectURL(newBlob);
				var link = document.createElement('a');
        	link.href = data;
        	link.download = "Facture " + this.invoice.number + ".pdf";
        	// this is necessary as link.click() does not work on the latest firefox
        	link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        	setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);	*/
		});
	}
	addAcompte() {

		//this.acompteAmount = 500;
    this.acompteAmount.patchValue(500);
		this.displayAcompte = true;
	}
    createAcompteInvoice() {
    	this.store.dispatch(new actions.ExpertiseAddAcompteAction(this.expertise.id, this.acompteAmount.value));
      	this.displayAcompte = false;
    }
    createProvisionInvoice() {
        this.store.dispatch(new actions.ExpertiseAddAcompteAction(this.expertise.id, this.acompteAmount.value));
        this.displayProvision = false;
    }

}
